export default __webpack_public_path__ + "static/media/Sent - Message Send Sequence.e3c38b90.svg";